export const styles = {
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "30px",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  },
  formAndPreview: {
    display: "flex",
    gap: "32px",
    alignItems: "flex-start",
    flexWrap: "wrap",
  },
  previewWrapper: {
    flex: "0 0 320px",
    position: "sticky",
    top: "24px",
    padding: "16px",
    background: "rgba(10, 14, 39, 0.6)",
    borderRadius: "12px",
    border: "1px solid rgba(0, 212, 255, 0.25)",
  },
  previewTitle: {
    margin: "0 0 4px 0",
    fontSize: "1rem",
    fontWeight: "600",
    color: "#00D4FF",
    textTransform: "uppercase",
    letterSpacing: "1px",
  },
  previewHint: {
    margin: "0 0 12px 0",
    fontSize: "12px",
    color: "#B0BEC5",
  },
  previewFrame: {
    width: "100%",
    maxWidth: "288px",
    margin: "0 auto",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
    border: "1px solid rgba(0, 212, 255, 0.2)",
  },
  previewHeader: {
    padding: "10px 12px",
  },
  previewHeaderContent: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  previewAvatar: {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    overflow: "hidden",
    background: "rgba(255,255,255,0.2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  previewAvatarImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  previewAvatarEmoji: {
    fontSize: "20px",
  },
  previewHeaderText: { flex: 1, minWidth: 0 },
  previewHeaderTitle: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#fff",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  previewHeaderSubtitle: {
    fontSize: "11px",
    color: "rgba(255,255,255,0.85)",
  },
  previewMessages: {
    padding: "12px",
    minHeight: "100px",
    background: "#f1f5f9",
  },
  previewMessageRow: {
    display: "flex",
    marginBottom: "8px",
  },
  previewBubble: {
    maxWidth: "85%",
    padding: "8px 12px",
    borderRadius: "12px",
    fontSize: "12px",
    lineHeight: 1.4,
  },
  previewBubbleBot: {
    borderTopLeftRadius: "4px",
    color: "#1e293b",
  },
  previewBubbleUser: {
    borderTopRightRadius: "4px",
    color: "#fff",
  },
  previewFooter: {
    padding: "6px 12px",
    fontSize: "10px",
    color: "#64748b",
    background: "#e2e8f0",
    borderTop: "1px solid #cbd5e1",
  },
  previewInputRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 12px",
    background: "#e2e8f0",
    borderTop: "1px solid #cbd5e1",
  },
  previewInput: {
    flex: 1,
    padding: "8px 10px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    fontSize: "12px",
    background: "#fff",
    color: "#1e293b",
  },
  previewSendBtn: {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    flexShrink: 0,
  },
  title: {
    textAlign: "center",
    marginBottom: "24px",
    fontSize: "2rem",
    fontWeight: "700",
    background: "linear-gradient(135deg, #B026FF 0%, #00D4FF 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    textTransform: "uppercase",
    letterSpacing: "2px",
  },
  message: {
    padding: "12px 16px",
    borderRadius: "8px",
    marginBottom: "20px",
    textAlign: "center",
    fontWeight: "600",
    fontSize: "14px",
  },
  clientSelector: {
    marginBottom: "24px",
    padding: "20px",
    background: "rgba(10, 14, 39, 0.6)",
    borderRadius: "12px",
    border: "1px solid rgba(0, 212, 255, 0.2)",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    flex: "1 1 400px",
    minWidth: 0,
  },
  section: {
    padding: "24px",
    background: "linear-gradient(135deg, rgba(10, 14, 39, 0.9) 0%, rgba(176, 38, 255, 0.25) 100%)",
    borderRadius: "12px",
    marginBottom: "16px",
    border: "1px solid rgba(0, 212, 255, 0.3)",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
    backdropFilter: "blur(10px)",
  },
  sectionTitle: {
    margin: "0 0 20px 0",
    fontSize: "1.1rem",
    fontWeight: "600",
    color: "#00D4FF",
    textTransform: "uppercase",
    letterSpacing: "1px",
    borderBottom: "1px solid rgba(0, 212, 255, 0.3)",
    paddingBottom: "10px",
  },
  formRow: {
    display: "flex",
    gap: "20px",
    marginBottom: "15px",
    flexWrap: "wrap",
  },
  formGroup: {
    flex: "1",
    minWidth: "200px",
    marginBottom: "20px",
  },
  label: {
    display: "block",
    marginBottom: "14px",
    fontWeight: "600",
    fontSize: "12px",
    color: "#B0BEC5",
    textTransform: "uppercase",
    letterSpacing: "1px",
  },
  input: {
    width: "100%",
    padding: "12px 14px",
    borderRadius: "8px",
    border: "1px solid rgba(0, 212, 255, 0.3)",
    fontSize: "14px",
    background: "rgba(10, 14, 39, 0.8)",
    color: "#E2E8F0",
    marginTop: "12px",
    display: "block",
  },
  textarea: {
    width: "100%",
    padding: "12px 14px",
    borderRadius: "8px",
    border: "1px solid rgba(0, 212, 255, 0.3)",
    fontSize: "14px",
    fontFamily: "inherit",
    background: "rgba(10, 14, 39, 0.8)",
    color: "#E2E8F0",
    resize: "vertical",
    marginTop: "12px",
    display: "block",
  },
  select: {
    width: "100%",
    padding: "12px 14px",
    borderRadius: "8px",
    border: "1px solid rgba(0, 212, 255, 0.3)",
    fontSize: "14px",
    background: "rgba(10, 14, 39, 0.8)",
    color: "#E2E8F0",
  },
  colorInput: {
    width: "50px",
    height: "36px",
    padding: "2px",
    border: "1px solid rgba(0, 212, 255, 0.4)",
    borderRadius: "8px",
    marginLeft: "10px",
    marginTop: "12px",
    cursor: "pointer",
    background: "rgba(10, 14, 39, 0.6)",
    display: "inline-block",
    verticalAlign: "middle",
  },
  button: {
    padding: "14px 28px",
    background: "linear-gradient(135deg, #B026FF 0%, #0066FF 100%)",
    color: "#FFF",
    border: "1px solid #00D4FF",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "1px",
    marginTop: "20px",
    boxShadow: "0 0 20px rgba(0, 212, 255, 0.2)",
  },
  providerInfo: {
    background: "rgba(0, 212, 255, 0.1)",
    padding: "12px 14px",
    borderRadius: "8px",
    fontSize: "14px",
    color: "#B0BEC5",
    marginTop: "10px",
    border: "1px solid rgba(0, 212, 255, 0.2)",
  },
  helpSection: {
    marginTop: 48,
    paddingTop: 24,
    borderTop: "1px solid rgba(0, 212, 255, 0.2)",
  },
  helpTitle: {
    color: "#00D4FF",
    fontSize: "1rem",
    fontWeight: 600,
    marginBottom: 16,
    textTransform: "uppercase",
    letterSpacing: 1,
  },
  helpIframeWrapper: {
    position: "relative",
    paddingBottom: "56.25%",
    height: 0,
    overflow: "hidden",
    maxWidth: 800,
    margin: "0 auto",
    borderRadius: 12,
    border: "1px solid rgba(0, 212, 255, 0.3)",
  },
  helpIframe: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
};
